import { useState } from "react";
import { Check, Minus, Plus } from "lucide-react";
import { toast } from "sonner";
import { FALLBACK } from "@/data";
import { adminApi, errorText } from "./api";

function StockRow({ variant, stock, onSaved }) {
  const [value, setValue] = useState(stock);
  const dirty = value !== stock;
  const save = async () => {
    try { await adminApi.put(`/stock/${variant.id}`, { stock: value }); toast.success(`Stock ${variant.name} : ${value}`); onSaved(); }
    catch (e) { toast.error(errorText(e, "Enregistrement impossible")); }
  };
  const level = stock === 0 ? "out" : stock <= 3 ? "low" : "ok";
  return (
    <div className="vf-stock-row" data-testid={`stock-row-${variant.id}`}>
      <span className={`vf-swatch ${variant.id}`} />
      <div className="vf-stock-name"><b>{variant.name}</b><span>{variant.subtitle}</span></div>
      <span className={`vf-stock-pill ${level}`} data-testid={`stock-level-${variant.id}`}>{stock === 0 ? "Rupture" : stock <= 3 ? "Faible" : "En stock"}</span>
      <div className="vf-qty">
        <button onClick={() => setValue(Math.max(0, value - 1))} aria-label="Diminuer" data-testid={`stock-decrease-${variant.id}`}><Minus size={14} /></button>
        <input type="number" min="0" value={value} onChange={(e) => setValue(Math.max(0, Number(e.target.value) || 0))} data-testid={`stock-input-${variant.id}`} />
        <button onClick={() => setValue(value + 1)} aria-label="Augmenter" data-testid={`stock-increase-${variant.id}`}><Plus size={14} /></button>
      </div>
      <button className={`vf-stock-save ${dirty ? "dirty" : ""}`} onClick={save} disabled={!dirty} data-testid={`stock-save-${variant.id}`}><Check size={14} /> Enregistrer</button>
    </div>
  );
}

export default function AdminStock({ stock, onChanged }) {
  return (
    <section className="vf-admin-block" data-testid="admin-stock">
      <header><div><p className="vf-kicker">Inventaire</p><h2>Stock des <em>plateformes</em></h2></div></header>
      {FALLBACK.variants.map((v) => <StockRow key={`${v.id}-${stock[v.id]}`} variant={v} stock={stock[v.id] ?? 0} onSaved={onChanged} />)}
    </section>
  );
}
